import { computed } from 'vue';
import { useMapGetter } from './store';
import { useAccount } from './useAccount';

/**
 * Composable for component versioning.
 * Allows different accounts to use different versions of UI components.
 * @param {string} componentName - The name of the component to get the version for.
 * @returns {Object} An object containing version-related properties and methods.
 */
export function useComponentVersion(componentName) {
  const { accountId } = useAccount();
  const getComponentVersion = useMapGetter('accounts/getComponentVersion');

  /**
   * The current version of the component for this account.
   * @type {import('vue').ComputedRef<string>}
   */
  const version = computed(() =>
    getComponentVersion.value(accountId.value, componentName)
  );

  /**
   * Check if the current version matches the given version.
   * @param {string} v - The version to check against.
   * @returns {boolean} True if the current version matches.
   */
  const isVersion = v => version.value === v;

  return {
    version,
    isVersion,
  };
}
